import React from 'react';

function SpaceBetween(props: {children: React.ReactNode}) {
    return (
        <div className={"atoms-layouts-spacebetween"}>
            {props.children}
        </div>
    );
}

export default SpaceBetween;
